import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AccordionComponent } from '../../../../shared/components/accordion/accordion.component';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import {
  PAGE_CONSTANTS,
  TABS,
} from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import {
  DialogService,
  DialogConfig,
} from '../../../../shared/services/dialog.service';
import { TimesheetViewComponent } from '../timesheet-view/timesheet-view.component';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { LookupService } from '../../../../services/lookup.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ListService } from '../../../../shared/services/list.service';
import { TimesheetProviderProcessedListComponent } from "../timesheet-provider-processed-list/timesheet-provider-processed-list.component";
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-provider-list',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AuthorizeDirective,
    TimesheetNewEntriesComponent,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    TimesheetViewComponent,
    TimesheetProviderProcessedListComponent
],
  templateUrl: './timesheet-provider-list.component.html',
  styleUrl: './timesheet-provider-list.component.css',
})
export class TimesheetProviderListComponent implements OnInit {
  entry!: string;
  sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  pageId: string = PAGE_CONSTANTS.PROVIDER_LEADS_DATA_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  actionButtons: TableRowActionsModel = new TableRowActions({ view: true });
  @ViewChild('timesheetDialog') timesheetDialog!: TemplateRef<any>;
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  @ViewChild('timeoffViewDialog') timeoffViewDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  tabId: string = TABS.TIMESHEET;
  programName!: string;
  timeEntry = '';
  title = '';
  isProcessed = false;
  isViewTimeOff = false;
  inProgressPayroll: any;
  statusList: any;
  timesheetSearchForm!: FormGroup;
  providerId: any;
  action: any;
  addDialogId: any;
  payrollScheduleId: any;
  timesheetData: any;
  filetredPayPeriod: any;
  consumers: any[] = [];
  payPeriod: any[] = [];

  constructor(
    private fb: FormBuilder,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private listService: ListService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    const selectedProgram = this.userService.getSelectedProgram();
    this.providerId = JSON.parse(this.userService.getSelectedLead()!);
    this.programName = selectedProgram?.program_code ?? '';
    this.statusList = this.lookupService
      .getLookupValue('Business Status')
      .filter((item: any) => ['P', 'D'].includes(item.lkpValueCode));

    this.timesheetSearchForm = this.fb.group({
      payPeriod: [null],
      consumer: [null],
      status: [null],
      chequeNumber: [null],
    });
    this.setPageAccess();
    this.getConsumers();
    this.getPayPeriod();
    this.getInitData();
  }

  getInitData() {
   
    const inProcessPayload = this.buildRequestPayload(
      'providertimesheetlist1',
      'tasMasterPayrollScheduleId'
    );
    
    this.listService
      .getListData(inProcessPayload, 'claims')
      .subscribe((data: any) => {
        this.inProgressPayroll = this.filterRecords(data.responsedata);
      });
  }

  filterPayrollDates(payrolls: any, flow: any) {
    const today = new Date();
    if(flow === 'timeEntry'){
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return startDate <= today || (today >= startDate && today <= endDate);
    });
    }
    else{
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return (startDate >= today || (today >= startDate && today <= endDate));
    });
    }
  };

  buildRequestPayload(pageName: string, orderBy: string) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: [
        {
          jsonPath: 'providerId',
          value: this.providerId,
          operator: 'Equal',
        },
      ],
      orderByColumn: [orderBy],
      orderBy: ['desc'],
    };
    return payload;
  }

  getConsumers() {
    this.timesheetService
      .getConsumerList(this.programName, this.providerId)
      .subscribe((data: any) => {
        this.consumers = data.responsedata;
      });
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  onView(data: any) {
    this.payrollScheduleId = data.tasMasterPayrollScheduleId;
    if (this.isProcessed) {
      this.openViewPopup();
    } else {
      this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
      const tsPayload = {
        programCode: this.programName,
        consumerId: data.consumerId,
        providerId: data.providerId,
        payrollScheduleId: data.tasMasterPayrollScheduleId,
      };
      this.timesheetService.getTimesheet(tsPayload).subscribe((data: any) => {
        this.action = 'edit';
        this.title = 'Edit Time Entry';
        this.timesheetData = data.responsedata;
        this.openAddPopup();
      });
    }
  }

  timesheetAdded(event: any) {
    if (event.timesheetAdded) {
      this.closeAddDialog();
    }
  }

  closeAddDialog() {
    if (this.addDialogId) {
      this.dialogSvc.closeDialog(this.addDialogId);
      this.getInitData();
      this.addDialogId = null;
    }
  }

  addTimeentries() {
    this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
    this.timeEntry = 'timeEntry';
    this.title = 'Add New Time Entry';
    this.action = 'add';
    this.openAddPopup();
  }
  
  addTimeoff() {
    this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeOff');
    this.timeEntry = 'timeOff';
    this.action = 'addTimeOff';
    this.title = 'Add New Time Off';
    this.openAddPopup();
  }

  viewTimeOff() {
    console.log('view timeoff');
    this.isViewTimeOff = true;
    const dialogConfig: DialogConfig = {
      title: 'View Time Off',
      isOkText: 'Ok',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.timeoffViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openAddPopup() {
    const dialogConfig: DialogConfig = {
      title: this.title,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.addDialogId = this.dialogSvc.openDialog(
      this.timesheetDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  filterRecords(data: any) {
    data.sort((a : any, b: any) => {
      const dateA = new Date(a.fromDate);
      const dateB = new Date(b.fromDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  onAction(event: any, isProcessed: boolean) {
    if (event.action === 'view') {
      this.isProcessed = isProcessed;
      this.onView(event.data);
    }
  }

  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    this.timeEntry = '';
  }
}
